import { render } from "./RequestPasswordOrIdForgottenComponent.vue?vue&type=template&id=c759aa44"
import script from "./RequestPasswordOrIdForgottenComponent.vue?vue&type=script&lang=js"
export * from "./RequestPasswordOrIdForgottenComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__